module.exports = __webpack_public_path__ + "img/hieu-smc.36cab5f5.jpg";